// reason types for reason names
export const DNR_TYPE = 'DNR';
export const CANCEL_TYPE = 'Cancel';
export const PAUSE_BILLING_TYPE = 'PauseBilling';
export const UPLIFT_EXEMPT_TYPE = 'UpliftExemption';
export const DATES_MODIFIED = 'DatesModified';
export const CONTRACT_IQ_TYPE = 'ContractIQ';
export const SELECTIVE_BILLING_INVOICE = 'SelectiveBillingInvoice';
export const SELECTIVE_BILLING_REINVOICE = 'SelectiveBillingReinvoice';
export const SELECTIVE_BILLING_ABANDONED = 'SelectiveBillingAbandoned';
export const SELECTIVE_BILLING_REINSTATE = 'SelectiveBillingReinstate';